var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var Link = require('react-router').Link;
var MessageDetail = require('./layout/messageDetail.jsx');

var Message = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function(){
        var token = this.props.auth.token;

        if(token){
            this.props.fetchTagsIfNeeded(token);
            this.props.fetchTargetsIfNeeded(token);
            this.props.fetchMessageIfNeeded(this.props.params.id, token);
        }
    },

    hasDataLoaded: function(){
        return !!(this.props.message.messageData && Object.keys(this.props.targets).length > 0 && Object.keys(this.props.tags).length > 0);
    },

    getContent: function(){
        var children = [
            <div className="action-bar" key={0}>
                <div className="row column clearfix">
                    <div className="float-right">
                        <Link to={'/admin/message-center/' + this.props.params.id + '/edit'}>
                            <span className="ion-ios-compose-outline"></span>
                            Edit Message
                        </Link>
                        <Link to={'/admin/message-center/' + this.props.params.id + '/copy'}>
                            <span className="ion-ios-copy-outline"></span>
                            Copy Message
                        </Link>
                    </div>
                </div>
            </div>,
            <div className="row" key={1}>
                <div className="small-12 column end">
                    <MessageDetail
                        message={this.props.message.messageData}
                        tags={this.props.tags}
                        targets={this.props.targets} />
                </div>
            </div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function () {
        return (
            <div className="content">
                <Helmet title='Message Detail' />
                {this.getContent()}
            </div>
        );
    }
});

module.exports = Message;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/message.jsx